import { combineReducers } from 'redux';
import confirmBookings from 'store/reducers/booking/confirmBookings';
import saveGuestToDraft from 'store/reducers/booking/saveGuestToDraft';
import removeGuestFromRoom from 'store/reducers/booking/removeGuestFromRoom/index';

export default combineReducers({
  confirmBookings,
  saveGuestToDraft,
  removeGuestFromRoom
});